import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../config';

export default function ClientDetails({ clientId, token, onBack }) {
  const [client, setClient] = useState(null);
  const [orders, setOrders] = useState([]);
  const [tab, setTab] = useState('overview');

  useEffect(() => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    axios.get(`${API}/admin/clients/${clientId}`).then(r => setClient(r.data.user)).catch(()=>{});
    axios.get(`${API}/orders?client_id=${clientId}&limit=100`).then(r => setOrders(r.data.orders || [])).catch(()=>{});
  }, [clientId, token]);

  if (!client) return <div style={{color:'#fff',padding:'40px',textAlign:'center'}}>⏳ جاري التحميل...</div>;

  const delivered = orders.filter(o => o.status === 'delivered');
  const cancelled = orders.filter(o => o.status === 'cancelled');
  const totalSpent = delivered.reduce((s,o) => s + parseFloat(o.base_price||0), 0);

  return (
    <div style={{direction:'rtl',minHeight:'100vh',background:'#0f172a',padding:'24px'}}>
      <button onClick={onBack} style={{background:'none',border:'1px solid #334155',color:'#94a3b8',padding:'8px 16px',borderRadius:'8px',cursor:'pointer',fontSize:'13px',marginBottom:'20px'}}>← رجوع</button>

      <div style={{background:'linear-gradient(135deg,#667eea,#764ba2)',borderRadius:'16px',padding:'24px',marginBottom:'20px',color:'#fff',display:'flex',alignItems:'center',gap:'16px'}}>
        <div style={{width:'70px',height:'70px',borderRadius:'50%',background:'rgba(255,255,255,0.2)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'32px'}}>👤</div>
        <div>
          <h2 style={{margin:'0 0 4px',fontSize:'22px',fontWeight:'900'}}>{client.full_name}</h2>
          <p style={{margin:'0 0 2px',fontSize:'14px',opacity:0.8}}>📞 {client.phone}</p>
          {client.email && <p style={{margin:0,fontSize:'14px',opacity:0.8}}>✉️ {client.email}</p>}
          <span style={{display:'inline-block',marginTop:'8px',padding:'3px 12px',borderRadius:'20px',fontSize:'12px',background:client.is_active===false?'#ef444444':'#10b98144',color:client.is_active===false?'#fca5a5':'#6ee7b7'}}>
            {client.is_active===false?'⛔ موقوف':'✅ نشط'}
          </span>
        </div>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'12px',marginBottom:'20px'}}>
        {[['📦',orders.length,'إجمالي الطلبات'],['✅',delivered.length,'مكتمل'],['💰',totalSpent.toFixed(0)+' ج','إجمالي الإنفاق']].map(([ic,n,lb])=>(
          <div key={lb} style={{background:'#1e293b',borderRadius:'12px',padding:'16px',textAlign:'center'}}>
            <p style={{margin:'0 0 4px',fontSize:'24px'}}>{ic}</p>
            <p style={{margin:'0 0 2px',fontSize:'18px',fontWeight:'bold',color:'#fff'}}>{n}</p>
            <p style={{margin:0,fontSize:'11px',color:'#94a3b8'}}>{lb}</p>
          </div>
        ))}
      </div>

      <div style={{display:'flex',gap:'8px',marginBottom:'16px'}}>
        {[['overview','📋','نظرة عامة'],['orders','📦','الطلبات']].map(([id,ic,lb])=>(
          <button key={id} onClick={()=>setTab(id)} style={{flex:1,padding:'10px',borderRadius:'12px',border:'2px solid',borderColor:tab===id?'#667eea':'#334155',background:tab===id?'#667eea':'transparent',color:tab===id?'#fff':'#94a3b8',cursor:'pointer',fontSize:'13px',fontWeight:'bold'}}>
            {ic} {lb}
          </button>
        ))}
      </div>

      {tab==='overview' && (
        <div style={{background:'#1e293b',borderRadius:'14px',padding:'20px'}}>
          <h4 style={{margin:'0 0 12px',color:'#94a3b8',fontSize:'13px'}}>بيانات العميل</h4>
          {[['الاسم',client.full_name],['الهاتف',client.phone],['الإيميل',client.email||'—'],['الرصيد',`${parseFloat(client.wallet_balance||0).toFixed(2)} ج`],['تاريخ التسجيل',new Date(client.created_at).toLocaleDateString('ar-EG')],['الحالة',client.is_active===false?'موقوف':'نشط']].map(([l,v])=>(
            <div key={l} style={{display:'flex',justifyContent:'space-between',padding:'10px 0',borderBottom:'1px solid #334155',fontSize:'14px'}}>
              <span style={{color:'#64748b'}}>{l}</span>
              <span style={{color:'#e2e8f0',fontWeight:'bold'}}>{v}</span>
            </div>
          ))}
          <div style={{display:'flex',gap:'10px',marginTop:'16px'}}>
            <button onClick={async()=>{
              await axios.patch(`${API}/admin/clients/${clientId}/toggle`);
              axios.get(`${API}/admin/clients/${clientId}`).then(r=>setClient(r.data.user));
            }} style={{flex:1,padding:'12px',background:client.is_active===false?'#10b981':'#ef4444',color:'#fff',border:'none',borderRadius:'10px',cursor:'pointer',fontWeight:'bold'}}>
              {client.is_active===false?'✅ تفعيل الحساب':'⛔ إيقاف الحساب'}
            </button>
            <button onClick={async()=>{
              if(window.confirm(`هل أنت متأكد من حذف ${client.full_name} نهائياً؟ لا يمكن التراجع!`)){
                await axios.delete(`${API}/admin/clients/${clientId}`);
                onBack();
              }
            }} style={{flex:1,padding:'12px',background:'#1e1e1e',color:'#ef4444',border:'1px solid #ef4444',borderRadius:'10px',cursor:'pointer',fontWeight:'bold'}}>
              🗑️ حذف نهائي
            </button>
          </div>
        </div>
      )}

      {tab==='orders' && (
        <div>
          {orders.length===0 ? (
            <p style={{color:'#64748b',textAlign:'center',padding:'40px'}}>لا توجد طلبات</p>
          ) : orders.map(o=>(
            <div key={o.id} style={{background:'#1e293b',borderRadius:'12px',padding:'16px',marginBottom:'10px'}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:'8px'}}>
                <span style={{fontSize:'12px',color:'#64748b'}}>{new Date(o.requested_at).toLocaleDateString('ar-EG')}</span>
                <span style={{fontSize:'12px',fontWeight:'bold',padding:'2px 10px',borderRadius:'20px',background:o.status==='delivered'?'#14532d':o.status==='cancelled'?'#7f1d1d':'#1e3a5f',color:o.status==='delivered'?'#86efac':o.status==='cancelled'?'#fca5a5':'#93c5fd'}}>
                  {o.status==='delivered'?'✅ مكتمل':o.status==='cancelled'?'❌ ملغي':'⏳ جاري'}
                </span>
              </div>
              <p style={{margin:'0 0 4px',fontSize:'13px',color:'#e2e8f0'}}>📍 {(o.pickup_address||'').substring(0,40)}</p>
              <p style={{margin:'0 0 8px',fontSize:'13px',color:'#e2e8f0'}}>🏁 {(o.dropoff_address||'').substring(0,40)}</p>
              <div style={{display:'flex',justifyContent:'space-between'}}>
                <span style={{fontSize:'13px',color:'#94a3b8'}}>{o.driver_name||'لا يوجد طيار'}</span>
                <span style={{fontSize:'15px',fontWeight:'bold',color:'#667eea'}}>{o.base_price} ج</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
